import { store, type RootState } from '@/store/main';
import { globalRouteContext } from '@/store/router-context';
import { fetchPasscodeLists } from '@/store/slices/passcode-lists';
import { selectLoadedPasscodeLists } from '@/store/slices/passcode-lists/selectors';
import type { LoaderFunctionArgs } from 'react-router-dom';

export const audiencesLoader = async ({ context }: LoaderFunctionArgs): Promise<Response> => {
  try {
    const routeContext = context.get(globalRouteContext);
    if (routeContext.channel) {
      const state = store.getState() as RootState;
      const loadedPasscodeLists = selectLoadedPasscodeLists(state);
      if (!loadedPasscodeLists) {
        await store.dispatch(fetchPasscodeLists(routeContext.channel));
      }
    }
    return new Response(null, { status: 200 });
  } catch (e) {
    console.error(e);
    return new Response(null, { status: 500 });
  }
};
